import { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "../api/client";
import Bauchbinde from "../components/Bauchbinde";
import dayjs from "dayjs";

function flattenTops(nodes, tiefe = 0, prefix = "") {
  let out = [];
  (nodes || []).slice()
    .sort((a, b) => (a.position || 0) - (b.position || 0))
    .forEach((node, idx) => {
      const nummer = prefix ? prefix + "." + (idx + 1) : String(idx + 1);
      out.push({ top: node, tiefe, nummer });
      if (node.children && node.children.length)
        out = out.concat(flattenTops(node.children, tiefe + 1, nummer));
    });
  return out;
}

export default function ProjektorAnsicht1() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [daten, setDaten] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(null);

  const load = () => api.getProjektorDaten(id, 1, token).then(d => {
    setDaten(d);
    setLastUpdate(d.updated_at);
  });

  useEffect(() => {
    load();
    const interval = setInterval(load, 3000);
    return () => clearInterval(interval);
  }, [id, token]);

  if (!daten) return <div style={{ background: "#1a1a2e", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: "white", fontSize: 24 }}>Lädt…</div>;

  return (
    <div style={{ background: "#1a1a2e", minHeight: "100vh", color: "white", fontFamily: "Arial, sans-serif", padding: 40 }}>
      {/* Header */}
      <div style={{ borderBottom: "3px solid #cc0000", paddingBottom: 16, marginBottom: 32, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <div style={{ fontSize: 14, color: "#aaa", marginBottom: 4 }}>{daten.sitzung.gremium}</div>
          <div style={{ fontSize: 28, fontWeight: 700 }}>{daten.sitzung.titel}</div>
        </div>
        <div style={{ textAlign: "right", color: "#aaa", fontSize: 14 }}>
          <div>{dayjs(daten.sitzung.datum).format("DD.MM.YYYY")}</div>
          <div>{new Date().toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })} Uhr</div>
        </div>
      </div>

      {/* Aktiver TOP groß */}
      {daten.aktiver_top && (
        <div style={{ background: "#cc0000", borderRadius: 12, padding: "32px 40px", marginBottom: 40 }}>
          <div style={{ fontSize: 16, opacity: 0.8, marginBottom: 8 }}>Aktueller Tagesordnungspunkt</div>
          <div style={{ fontSize: 48, fontWeight: 900, lineHeight: 1.2, marginBottom: 12 }}>
            {(flattenTops(daten.tops).find(x => x.top.id === daten.aktiver_top.id)?.nummer
              || daten.aktiver_top.position)}. {daten.aktiver_top.titel}
          </div>
          <div style={{ display: "flex", gap: 16, fontSize: 14, opacity: 0.9 }}>
            {daten.aktiver_top.top_typ === "beschluss" && <span>🗳 Beschlussvorhaben</span>}
            {daten.aktiver_top.top_typ === "information" && <span>ℹ Informationspunkt</span>}
            {daten.aktiver_top.abstimmung_ergebnis && (
              <span style={{ fontWeight: 700, fontSize: 18 }}>
                {daten.aktiver_top.abstimmung_ergebnis === "angenommen" ? "✓ ANGENOMMEN" : "✕ ABGELEHNT"}
              </span>
            )}
          </div>
        </div>
      )}

      {/* Tagesordnung */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 12 }}>
        {flattenTops(daten.tops).filter(({ top }) => top.oeffentlich !== false).map(({ top, tiefe, nummer }) => (
          <div key={top.id} style={{
            background: daten.aktiver_top?.id === top.id ? "rgba(204,0,0,0.3)" : "rgba(255,255,255,0.05)",
            border: daten.aktiver_top?.id === top.id ? "2px solid #cc0000" : "2px solid transparent",
            borderRadius: 8, padding: "12px 16px", marginLeft: tiefe * 24,
            display: "flex", gap: 12, alignItems: "center"
          }}>
            <div style={{ width: tiefe > 0 ? 30 : 36, height: tiefe > 0 ? 30 : 36, borderRadius: "50%",
              background: daten.aktiver_top?.id === top.id ? "#cc0000" : "rgba(255,255,255,0.1)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontWeight: 700, fontSize: tiefe > 0 ? 11 : 14, flexShrink: 0 }}>
              {nummer}
            </div>
            <div style={{ fontSize: tiefe > 0 ? 13 : 15, fontWeight: daten.aktiver_top?.id === top.id ? 700 : 400 }}>
              {top.titel}
            </div>
          </div>
        ))}
      </div>
      <Bauchbinde text={daten.bauchbinde_text} sichtbar={daten.bauchbinde_sichtbar} />
    </div>
  );
}
